import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { IconSetService } from '@coreui/icons-angular';
import { freeSet } from '@coreui/icons';
import { UtilService } from './modules/shared/services/util/util.service';
import { projectConstants } from './constants/project.constants';
// import { LoadingBarService } from '@ngx-loading-bar/core';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  templateUrl: './app.component.html',
  providers: [IconSetService],
})
export class AppComponent implements OnInit {

  projectConstants = projectConstants;

  constructor(
    private router: Router,
    public iconSet: IconSetService,
    private utilService: UtilService
  ) {
    // iconSet singleton
    iconSet.icons = { ...freeSet };
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
    this.setDocTitle();
    this.setDocFavicon();
  }

  setDocTitle(): void {
    const docTitle = projectConstants.title;
    this.utilService.setDocTitle(docTitle);
  }

  setDocFavicon(): void {
    this.utilService.setDocFavicon();
  }
}
